import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { obtenerActividadesExtracurricularesPorNino, actualizarActividadExtracurricular } from '../../services/ActividadesService';
import { FaFile, FaCheckCircle, FaRegCircle, FaPencilAlt, FaTrash, FaUpload } from 'react-icons/fa';
import { X, SlidersHorizontal, Save } from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ActividadesExtracurricularesHijo = () => {
    const [actividades, setActividades] = useState([]);
    const [actividadesFiltradas, setActividadesFiltradas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [observaciones, setObservaciones] = useState({});
    const [archivoPadre, setArchivoPadre] = useState({});
    const [actualizando, setActualizando] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [actividadSeleccionada, setActividadSeleccionada] = useState(null);
    const [filtroEstado, setFiltroEstado] = useState('pendientes');
    const [filtroFecha, setFiltroFecha] = useState('proximas');
    const [filtroActivo, setFiltroActivo] = useState('estado');
    const [isDragging, setIsDragging] = useState(false);
    const [nombreArchivo, setNombreArchivo] = useState('');
    const [imagenAmpliada, setImagenAmpliada] = useState(false);
    const [archivosBorrados, setArchivosBorrados] = useState({});
    const [archivoError, setArchivoError] = useState('');

    useEffect(() => {
        const cargarActividades = async () => {
            try {
                const hijoSeleccionado = JSON.parse(localStorage.getItem('hijoSeleccionado'));
                if (!hijoSeleccionado) {
                    setError('No se ha seleccionado ningún hijo');
                    setLoading(false);
                    return;
                }

                const response = await obtenerActividadesExtracurricularesPorNino(hijoSeleccionado.id_child);

                if (!response.actividades) {
                    setError('No se recibieron datos de actividades');
                    setLoading(false);
                    return;
                }

                const actividadesRecibidas = response.actividades;
                
                // Verificar cada actividad
                actividadesRecibidas.forEach(act => {
                    if (act.completada) {
                        console.log(`Actividad ${act.id_actividad}:`, {
                            completada: act.completada,
                            archivo_padre: act.archivo_padre,
                            observaciones: act.observaciones
                        });
                    }
                });

                setActividades(actividadesRecibidas);
                
                // Inicializar estados
                const obsIniciales = {};
                const archivosIniciales = {};
                
                actividadesRecibidas.forEach(act => {
                    // Guardar observaciones
                    obsIniciales[act.id_actividad] = act.observaciones || '';
                    
                    // Guardar archivo_padre si existe
                    if (act.archivo_padre) {
                        archivosIniciales[act.id_actividad] = act.archivo_padre;
                    }
                });
                
                setObservaciones(obsIniciales);
                setArchivoPadre(archivosIniciales);
                
                setLoading(false);
            } catch (error) {
                console.error('Error detallado al cargar actividades:', error);
                setError('Error al cargar las actividades extracurriculares');
                setLoading(false);
            }
        };

        cargarActividades();
    }, []);

    useEffect(() => {
        const fechaActual = new Date();
        let actividadesFiltradas = [...actividades];

        if (filtroEstado === 'pendientes') {
            actividadesFiltradas = actividadesFiltradas.filter(act => !act.completada);
        } else if (filtroEstado === 'completadas') {
            actividadesFiltradas = actividadesFiltradas.filter(act => act.completada);
        }

        if (filtroFecha === 'proximas') {
            actividadesFiltradas = actividadesFiltradas.filter(act => 
                new Date(act.fecha_limite) >= fechaActual
            );
        } else if (filtroFecha === 'pasadas') {
            actividadesFiltradas = actividadesFiltradas.filter(act => 
                new Date(act.fecha_limite) < fechaActual
            );
        }

        setActividadesFiltradas(actividadesFiltradas);
    }, [actividades, filtroEstado, filtroFecha]);

    const abrirModal = (actividad) => {
        setActividadSeleccionada(actividad);
        setIsModalOpen(true);
    };

    const handleCompletarActividad = async (actividad, e) => {
        if (e) e.preventDefault();
        
        try {
            setActualizando(true);
            const datosActividad = {};

            // Si la actividad ya está completada, solo permitir actualizar observaciones y archivo_padre
            if (actividad.completada) {
                datosActividad.observaciones = observaciones[actividad.id_actividad] || '';
                
                // Solo incluir archivo_padre si hay uno nuevo o se va a borrar
                if (archivoPadre[actividad.id_actividad]) {
                    datosActividad.archivo_padre = archivoPadre[actividad.id_actividad];
                }
                if (archivosBorrados[actividad.id_actividad]) {
                    datosActividad.borrarArchivoPadre = true;
                }
            } else {
                // Si no está completada, incluir todos los campos necesarios
                datosActividad.completada = true;
                datosActividad.observaciones = observaciones[actividad.id_actividad] || '';
                datosActividad.titulo = actividad.titulo;
                datosActividad.descripcion = actividad.descripcion;
                datosActividad.fecha_limite = actividad.fecha_limite;

                if (archivoPadre[actividad.id_actividad]) {
                    datosActividad.archivo_padre = archivoPadre[actividad.id_actividad];
                }
                if (archivosBorrados[actividad.id_actividad]) {
                    datosActividad.borrarArchivoPadre = true;
                }
            }

            const response = await actualizarActividadExtracurricular(actividad.id_actividad, datosActividad);

            setActividades(actividades.map(act => 
                act.id_actividad === actividad.id_actividad 
                    ? {
                        ...act,
                        // Mantener el estado completada de la actividad existente si ya estaba completada
                        completada: actividad.completada ? true : datosActividad.completada,
                        observaciones: observaciones[actividad.id_actividad],
                        archivo_padre: archivosBorrados[actividad.id_actividad] ? null : response.actividad.archivo_padre
                    }
                    : act
            ));

            // Limpiar estados después de guardar
            setArchivosBorrados(prev => ({
                ...prev,
                [actividad.id_actividad]: false
            }));
            
            toast.success(
                actividad.completada 
                    ? 'Respuesta actualizada exitosamente'
                    : 'Actividad marcada como completada exitosamente', 
                {
                    position: 'top-right',
                    autoClose: 3000
                }
            );
            
            setIsModalOpen(false);
            setArchivoPadre(prev => ({
                ...prev,
                [actividad.id_actividad]: null
            }));

        } catch (error) {
            console.error('Error al actualizar la actividad:', error);
            toast.error('Error al actualizar la actividad', {
                position: 'top-right',
                autoClose: 3000
            });
        } finally {
            setActualizando(false);
        }
    };

    const handleObservacionesChange = (actividadId, valor) => {
        setObservaciones(prev => ({
            ...prev,
            [actividadId]: valor
        }));
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const validarArchivo = (file) => {
        setArchivoError('');
        
        // Validar tipo de archivo
        const tiposPermitidos = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'image/webp'];
        if (!tiposPermitidos.includes(file.type)) {
            setArchivoError('Solo se permiten archivos PDF e imágenes (JPEG, PNG, GIF, WEBP)');
            toast.error('Solo se permiten archivos PDF e imágenes (JPEG, PNG, GIF, WEBP)', {
                position: 'top-right',
                autoClose: 3000
            });
            return false;
        }

        // Validar tamaño (10MB = 10 * 1024 * 1024 bytes)
        const tamañoMaximo = 10 * 1024 * 1024;
        if (file.size > tamañoMaximo) {
            setArchivoError('El archivo no debe superar los 10MB');
            toast.error('El archivo no debe superar los 10MB', {
                position: 'top-right',
                autoClose: 3000
            });
            return false;
        }

        return true;
    };

    const handleDrop = (e, actividadId) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        const file = e.dataTransfer.files[0];
        if (file && validarArchivo(file)) {
            setArchivoPadre(prev => ({
                ...prev,
                [actividadId]: file
            }));
            setNombreArchivo(file.name);
        }
    };

    const handleArchivoChange = (actividadId, event) => {
        const file = event.target.files[0];
        if (file && validarArchivo(file)) {
            setArchivoPadre(prev => ({
                ...prev,
                [actividadId]: file
            }));
            setNombreArchivo(file.name);
        } else {
            event.target.value = ''; // Limpiar el input de archivo
        }
    };

    const eliminarComprobante = (actividadId) => {
        setArchivoPadre(prev => ({
            ...prev,
            [actividadId]: null
        }));
        setNombreArchivo('');
        setArchivosBorrados(prev => ({
            ...prev,
            [actividadId]: true
        }));
    };

    const limpiarFiltros = () => {
        setFiltroEstado('pendientes');
        setFiltroFecha('proximas');
    };

    const cambiarFiltroActivo = (nuevoFiltro) => {
        if (filtroActivo !== nuevoFiltro) {
            setFiltroActivo(nuevoFiltro);
            limpiarFiltros();
        }
    };

    const renderFiltroActivo = () => {
        switch(filtroActivo) {
            case 'estado':
                return (
                    <select 
                        value={filtroEstado}
                        onChange={(e) => setFiltroEstado(e.target.value)}
                        className="w-full rounded-lg border border-gray-300 bg-white py-2 pl-3 pr-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                    >
                        <option value="todos">Todos los estados</option>
                        <option value="pendientes">Pendientes</option>
                        <option value="completadas">Completadas</option>
                    </select>
                );
            case 'fecha':
                return (
                    <select 
                        value={filtroFecha}
                        onChange={(e) => setFiltroFecha(e.target.value)}
                        className="w-full rounded-lg border border-gray-300 bg-white py-2 pl-3 pr-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                    >
                        <option value="todas">Todas las fechas</option>
                        <option value="proximas">Próximas</option>
                        <option value="pasadas">Pasadas</option>
                    </select>
                );
            default:
                return null;
        }
    };

    const esFechaVencida = (fechaLimite) => {
        const hoy = new Date();
        const fecha = new Date(fechaLimite);
        hoy.setHours(0, 0, 0, 0);
        fecha.setHours(0, 0, 0, 0);
        return hoy > fecha;
    };

    const renderizarActividad = (actividad) => {
        const puedeEditar = !esFechaVencida(actividad.fecha_limite);
        
        return (
            <div 
                key={actividad.id_actividad}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow duration-200 border border-gray-100 mb-6"
            >
                <div className="flex justify-between items-start mb-4">
                    <h2 className="text-xl font-semibold text-gray-800">
                        {actividad.titulo}
                    </h2>
                    <div className="flex items-center gap-2">
                        {actividad.completada && puedeEditar && (
                    <button
                        onClick={() => abrirModal(actividad)}
                                className="flex items-center gap-1 px-3 py-1.5 text-sm bg-indigo-50 text-indigo-600 rounded-lg hover:bg-indigo-100 transition-colors"
                            >
                                <FaPencilAlt size={12} />
                                Editar respuesta
                            </button>
                        )}
                        <span className={`flex items-center gap-2 px-4 py-2 rounded-full transition-colors ${
                            actividad.completada 
                            ? 'bg-green-50 text-green-600'
                            : 'bg-gray-50 text-gray-600'
                        }`}>
                        {actividad.completada ? <FaCheckCircle /> : <FaRegCircle />}
                        {actividad.completada ? 'Completada' : 'Pendiente'}
                        </span>
                    </div>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg mb-4">
                    <p className="text-gray-700">{actividad.descripcion}</p>
                </div>

                <div className="flex items-center justify-between text-sm text-gray-500">
                    <div className="flex items-center gap-2">
                        <span className={`w-2 h-2 rounded-full ${esFechaVencida(actividad.fecha_limite) ? 'bg-red-500' : 'bg-purple-500'}`}></span>
                        <span>
                        Fecha límite: {new Date(actividad.fecha_limite).toLocaleDateString()}
                            {esFechaVencida(actividad.fecha_limite) && (
                                <span className="text-red-500 ml-2">(Vencida)</span>
                            )}
                        </span>
                    </div>
                    
                    {actividad.archivo && (
                        <a 
                            href={actividad.archivo}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 text-blue-600 hover:text-blue-700"
                        >
                            <FaFile />
                            Material de apoyo
                        </a>
                    )}
                </div>

                {actividad.completada && (
                    <div className="mt-4 space-y-4">
                        {actividad.observaciones && (
                            <div className="p-4 bg-green-50 rounded-lg border border-green-100">
                                <h4 className="text-sm font-medium text-green-800 mb-2">Tus observaciones:</h4>
                        <p className="text-sm text-green-700">{actividad.observaciones}</p>
                            </div>
                        )}
                        
                        {actividad.archivo_padre && (
                            <div className="p-4 bg-green-50 rounded-lg border border-green-100">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-2">
                                        <FaFile className="text-green-600" />
                                        <span className="text-sm font-medium text-green-800">Tu archivo de respuesta</span>
                                    </div>
                                    <a 
                                        href={actividad.archivo_padre}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-sm text-green-600 hover:text-green-800 font-medium"
                                    >
                                        Ver archivo
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {!actividad.completada && puedeEditar && (
                    <div className="mt-4">
                        <button
                            onClick={() => abrirModal(actividad)}
                            className="w-full py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors flex items-center justify-center gap-2"
                        >
                            <FaCheckCircle />
                            Marcar como completada
                        </button>
                    </div>
                )}

                {!puedeEditar && !actividad.completada && (
                    <div className="mt-4 p-3 bg-red-50 rounded-lg border border-red-100">
                        <p className="text-sm text-red-600 text-center">
                            No se puede completar esta actividad porque la fecha límite ha vencido
                        </p>
                    </div>
                )}
            </div>
        );
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center min-h-screen p-2 sm:p-4">
                <div className="animate-spin rounded-full h-8 w-8 sm:h-10 sm:w-10 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    if (error) {
        if (error === 'No se ha seleccionado ningún hijo') {
            return (
                <div className="min-h-screen flex items-center justify-center p-2 sm:p-4">
                    <div className="text-center p-4 sm:p-8 max-w-md">
                        <div className="mb-4">
                            <svg className="mx-auto h-12 w-12 sm:h-16 sm:w-16 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                        </div>
                        <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2">No hay estudiante seleccionado</h2>
                        <p className="text-sm sm:text-base text-gray-600">Por favor, selecciona un estudiante para ver sus actividades extracurriculares.</p>
                    </div>
                </div>
            );
        }
        return (
            <div className="min-h-screen flex items-center justify-center p-2 sm:p-4">
                <div className="text-center p-4 sm:p-8 max-w-md">
                    <div className="mb-4">
                        <svg className="mx-auto h-12 w-12 sm:h-16 sm:w-16 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2M7 7h10" />
                        </svg>
                    </div>
                    <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2">No hay actividades disponibles</h2>
                    <p className="text-sm sm:text-base text-gray-600">En este momento no hay actividades extracurriculares registradas. Las actividades se mostrarán aquí cuando estén disponibles.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 p-3 sm:p-6">
            <ToastContainer />
            <div className="max-w-4xl mx-auto">
                {/* Header Section */}
                <div className="bg-white rounded-xl sm:rounded-2xl shadow-sm overflow-hidden mb-4 sm:mb-6">
                    <div className="p-4 sm:p-6 border-b border-gray-100">
                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                            <div>
                                <h1 className="text-xl sm:text-2xl font-semibold text-gray-800">
                                    Actividades Extracurriculares
                                </h1>
                                <p className="text-xs sm:text-sm text-gray-500 mt-1">
                                    Gestiona las actividades extracurriculares de tu hijo
                                </p>
                            </div>
                            <div className="flex gap-2">
                                <button
                                    onClick={() => cambiarFiltroActivo('estado')}
                                    className={`px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-medium transition-all duration-200 ${
                                        filtroActivo === 'estado'
                                        ? 'bg-indigo-50 text-indigo-600'
                                        : 'text-gray-600 hover:bg-gray-50'
                                    }`}
                                >
                                    Estado
                                </button>
                                <button
                                    onClick={() => cambiarFiltroActivo('fecha')}
                                    className={`px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-medium transition-all duration-200 ${
                                        filtroActivo === 'fecha'
                                        ? 'bg-indigo-50 text-indigo-600'
                                        : 'text-gray-600 hover:bg-gray-50'
                                    }`}
                                >
                                    Fecha
                                </button>
                            </div>
                        </div>

                        {filtroActivo && (
                            <div className="mt-4">
                                <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
                                    <div className="w-full sm:flex-1">
                                        {renderFiltroActivo()}
                                    </div>
                                    {(filtroEstado !== 'todos' || filtroFecha !== 'todas') && (
                                        <button
                                            onClick={limpiarFiltros}
                                            className="text-xs sm:text-sm text-gray-500 hover:text-gray-700 transition-colors duration-200"
                                        >
                                            Limpiar filtros
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {actividadesFiltradas.length > 0 ? (
                    <div className="space-y-3 sm:space-y-4">
                        {actividadesFiltradas.map(renderizarActividad)}
                    </div>
                ) : (
                    <div className="text-center py-8 sm:py-12 bg-white rounded-lg sm:rounded-xl shadow-sm">
                        <svg className="mx-auto h-10 w-10 sm:h-12 sm:w-12 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                        <p className="mt-4 text-sm sm:text-base text-gray-500">
                            No hay actividades extracurriculares que coincidan con los filtros
                        </p>
                    </div>
                )}
            </div>

            <Modal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                className="fixed inset-0 flex items-center justify-center p-3 sm:p-4"
                overlayClassName="fixed inset-0 bg-black bg-opacity-50"
                contentLabel="Actualizar Estado"
                ariaHideApp={false}
            >
                <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-auto">
                    <div className="flex items-center justify-between p-3 sm:p-4 border-b border-gray-200">
                        <h2 className="text-base sm:text-lg font-semibold text-gray-900">
                            {actividadSeleccionada?.completada ? 'Marcar como pendiente' : 'Marcar como completada'}
                        </h2>
                        <button
                            onClick={() => setIsModalOpen(false)}
                            className="text-gray-400 hover:text-gray-600 transition-colors"
                        >
                            <X size={18} className="sm:w-5 sm:h-5" />
                        </button>
                    </div>

                    <div className="p-3 sm:p-4">
                        <div className="mb-4">
                            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                Observaciones (opcional)
                            </label>
                            <textarea
                                value={actividadSeleccionada ? observaciones[actividadSeleccionada.id_actividad] || '' : ''}
                                onChange={(e) => actividadSeleccionada && handleObservacionesChange(actividadSeleccionada.id_actividad, e.target.value)}
                                className="w-full rounded-lg border border-gray-300 bg-white py-2 px-3 text-xs sm:text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 resize-none"
                                rows="3"
                                placeholder="Agregar observaciones..."
                            />
                        </div>

                        <div className="mb-4">
                            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                Archivo de respuesta
                            </label>
                            
                            {archivoPadre[actividadSeleccionada?.id_actividad] ? (
                                <div className="flex items-center justify-between p-2 sm:p-3 bg-gray-50 rounded-lg sm:rounded-xl border border-gray-200">
                                    <div className="flex items-center space-x-3">
                                        <FaFile className="text-blue-500" size={16} />
                                        <div>
                                            <p className="text-xs sm:text-sm font-medium text-gray-700">{nombreArchivo}</p>
                                            {typeof archivoPadre[actividadSeleccionada.id_actividad] === 'string' ? (
                                                <a 
                                                    href={archivoPadre[actividadSeleccionada.id_actividad]}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-xs text-blue-600 hover:text-blue-800"
                                                >
                                                    Ver archivo
                                                </a>
                                            ) : (
                                                <span className="text-xs text-gray-500">Archivo nuevo sin guardar</span>
                                            )}
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => eliminarComprobante(actividadSeleccionada.id_actividad)}
                                        className="p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
                                    >
                                        <FaTrash size={12} className="sm:w-3.5 sm:h-3.5" />
                                    </button>
                                </div>
                            ) : (
                                <div>
                                    <div 
                                        className={`relative ${isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300 bg-gray-50'}`}
                                        onDragEnter={handleDragEnter}
                                        onDragLeave={handleDragLeave}
                                        onDragOver={handleDragOver}
                                        onDrop={(e) => actividadSeleccionada && handleDrop(e, actividadSeleccionada.id_actividad)}
                                    >
                                        <input
                                            type="file"
                                            accept=".pdf,image/*"
                                            onChange={(e) => actividadSeleccionada && handleArchivoChange(actividadSeleccionada.id_actividad, e)}
                                            className="hidden"
                                            id="comprobante"
                                        />
                                        <label
                                            htmlFor="comprobante"
                                            className="flex flex-col items-center justify-center space-y-2 w-full px-3 sm:px-4 py-4 sm:py-6 border-2 border-dashed rounded-lg sm:rounded-xl cursor-pointer hover:bg-gray-100 transition-colors"
                                        >
                                            <FaUpload className="text-gray-500" size={20} />
                                            <div className="text-center">
                                                <p className="text-xs sm:text-sm text-gray-600">Arrastra y suelta archivos aquí o</p>
                                                <p className="text-xs sm:text-sm text-blue-600 font-medium">Haz clic para seleccionar</p>
                                                <p className="text-xs text-gray-500 mt-1">Solo PDF e imágenes (máx. 10MB)</p>
                                            </div>
                                        </label>
                                    </div>
                                    {archivoError && (
                                        <p className="text-red-500 text-xs sm:text-sm mt-2">{archivoError}</p>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="flex justify-end gap-2 sm:gap-3 mt-4 sm:mt-6">
                            <button
                                onClick={() => setIsModalOpen(false)}
                                className="rounded-lg font-medium transition-all duration-300 flex items-center justify-center shadow-sm px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm bg-transparent text-gray-600 hover:bg-gray-50"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={(e) => actividadSeleccionada && handleCompletarActividad(actividadSeleccionada, e)}
                                disabled={actualizando}
                                className="rounded-lg font-medium transition-all duration-300 flex items-center justify-center shadow-sm px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm bg-indigo-500 text-white hover:bg-indigo-600"
                            >
                                <Save className="mr-1.5 sm:mr-2 w-3.5 h-3.5 sm:w-4 sm:h-4" />
                                {actualizando ? 'Actualizando...' : 'Guardar'}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ActividadesExtracurricularesHijo;
